import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import cn from 'classnames';

import { conditional } from 'utils/shapes';

import BikeCardPrice from './BikeCardPrice';
import BikeCardInfo from './BikeCardInfo';
import BikeCardGallery from './BikeCardGallery';
import BikeCardRating from './BikeCardRating';

import './BikeCard.css';

const BikeCard = ({
  average,
  bike,
  bikeTypes,
  currency,
  href,
  onClick,
  showBikeLocation,
  showBikeLocationLink,
  showProvider,
  showRating
}) => (
  <div className="bike-card">
    <Row>
      <Col lg={4} md={4} sm={5} xs={12}>
        <BikeCardGallery
          photos={bike.photos}
          className={cn({ 'bike-card-gallery-rating': showRating })}
        />

        {showRating && (
          <BikeCardRating
            bike={bike}
            showProvider={showProvider}
          />
        )}
      </Col>

      <Col lg={4} md={4} sm={7} xs={12}>
        <BikeCardInfo
          bike={bike}
          bikeTypes={bikeTypes}
          showBikeLocation={showBikeLocation}
          showBikeLocationLink={showBikeLocationLink}
        />
      </Col>

      <Col lg={4} md={4} sm={12} xs={12}>
        <BikeCardPrice
          average={average}
          bike={bike}
          href={href}
          currency={currency}
          onClick={onClick}
        />
      </Col>
    </Row>
  </div>
);

BikeCard.propTypes = {
  average: PropTypes.bool,
  currency: PropTypes.string.isRequired,
  bike: PropTypes.object.isRequired,
  bikeTypes: PropTypes.array,
  href: PropTypes.string,
  showBikeLocationLink: PropTypes.bool.isRequired,
  showBikeLocation: conditional('showBikeLocationLink', PropTypes.func.isRequired),
  onClick: PropTypes.func.isRequired,
  showProvider: PropTypes.bool,
  showRating: PropTypes.bool.isRequired
};

BikeCard.defaultProps = {
  showBikeLocationLink: true,
  showProvider: true,
  showRating: true
};

export default BikeCard;

export {
  BikeCardGallery
};



// WEBPACK FOOTER //
// ./src/widgets/BikeCard/index.js